module.exports = __webpack_public_path__ + "img/ico-reset-sort.cafb6eb1.png";